// frontend/src/services/connectionsService.ts

import axiosInstance from '../config/axiosInstance';
import { 
  Connection, 
  ConnectionCreatePayload, 
  TestConnectionResponse, 
  ConnectionUpdatePayload,
  // --- INICIO: NUEVOS TIPOS A IMPORTAR ---
  SchemaDiscoveryPayload,
  SchemaDiscoveryResponse
  // --- FIN: NUEVOS TIPOS A IMPORTAR ---
} from '../types';

/**
 * Obtiene la lista de todas las conexiones configuradas por el usuario.
 * @returns Una promesa que se resuelve en un array de objetos Connection.
 */
export const listConnections = async (): Promise<Connection[]> => {
  const response = await axiosInstance.get<Connection[]>('/connections');
  return response.data;
};

/**
 * Crea una nueva conexión para el usuario.
 * @param connectionData - El payload que contiene los detalles de la nueva conexión.
 * @returns Una promesa que se resuelve en el objeto Connection recién creado.
 */
export const createConnection = async (connectionData: ConnectionCreatePayload): Promise<Connection> => {
  const response = await axiosInstance.post<Connection>('/connections', connectionData);
  return response.data;
};

/**
 * Envía una petición para probar una conexión existente.
 * @param connectionId - El ID de la conexión a probar.
 * @returns Una promesa que se resuelve en la respuesta del test.
 */
export const testConnection = async (connectionId: string): Promise<TestConnectionResponse> => {
  const response = await axiosInstance.post<TestConnectionResponse>(`/connections/${connectionId}/test`);
  return response.data;
};

/**
 * Actualiza el estado (activo/inactivo) de una conexión.
 * @param id - El ID de la conexión a actualizar.
 * @param isActive - El nuevo estado.
 * @returns Una promesa que se resuelve en la conexión actualizada.
 */
export const updateConnectionStatus = async (id: string, isActive: boolean): Promise<Connection> => {
  const payload: ConnectionUpdatePayload = { is_active: isActive };
  const { data } = await axiosInstance.patch(`/connections/${id}`, payload);
  return data;
};

// --- INICIO: NUEVA FUNCIÓN DE DESCUBRIMIENTO DE ESQUEMA ---
/**
 * Envía credenciales a la API para descubrir los recursos y columnas disponibles.
 * Esta operación NO guarda la conexión.
 * @param payload - Los datos de conexión (tipo y credenciales) a probar.
 * @returns Una promesa que se resuelve con los recursos y columnas descubiertos.
 */
export const discoverSchema = async (payload: SchemaDiscoveryPayload): Promise<SchemaDiscoveryResponse> => {
  const response = await axiosInstance.post<SchemaDiscoveryResponse>('/connections/schema', payload);
  return response.data;
};
// --- FIN: NUEVA FUNCIÓN DE DESCUBRIMIENTO DE ESQUEMA ---